import { render, staticRenderFns } from "./AxaptBillsList.vue?vue&type=template&id=4350471f&"
import script from "./AxaptBillsList.js?vue&type=script&lang=js&"
export * from "./AxaptBillsList.js?vue&type=script&lang=js&"
import style0 from "./AxaptBillsList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports